import styled from 'styled-components';
import colors from '../../styles/colors';
import Button from '../Button/Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 350px;
  flex: 1;
`;

const LoadMoreButton = styled(Button)`
  height: 40px;
  background: ${colors.shades.gamma5};
  color: ${colors.shades.gamma7};
  border: 1px solid ${colors.shades.gamma4};
  font-size: 14px;
  cursor: pointer;
`;

const ChannelListMenu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: left;
  padding: 16px;
  background: ${colors.base.secondary2};
`;

const ChannelListMenuActions = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ListItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
`;

const ArchiveButton = styled(Button)`
  width: max-content;
  height: 30px;
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
  padding: 8px 12px;
  border-radius: 5px;
  background-color: ${colors.base.primary};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 8px;
  width: 100%;
`;

export {
  Container,
  LoadMoreButton,
  ChannelListMenu,
  ListItemsContainer,
  ChannelListMenuActions,
  ArchiveButton,
  CheckboxRow,
};
